import { render, staticRenderFns } from "./FactsHome.vue?vue&type=template&id=4202d85e&scoped=true&"
import script from "./FactsHome.vue?vue&type=script&lang=js&"
export * from "./FactsHome.vue?vue&type=script&lang=js&"
import style0 from "./FactsHome.vue?vue&type=style&index=0&id=4202d85e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4202d85e",
  null
  
)

export default component.exports